function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState, useRef, useEffect } from 'react';
import { Modal } from 'react-native';
/**
 * 包装组件，支持组件的方式调用
 */
export function wrapFC(Children) {
  return function (props) {
    const {
      visible
    } = props;
    // 为了保证组件的动画，内部需要单独控制组件的展示和隐藏
    const [control, setControl] = useState(visible);
    const ref = useRef(null);
    useEffect(() => {
      if (!visible && control) {
        var _ref$current, _ref$current$close;
        (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : (_ref$current$close = _ref$current.close) === null || _ref$current$close === void 0 ? void 0 : _ref$current$close.call(_ref$current);
      } else if (visible) {
        setControl(true);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible]);
    return /*#__PURE__*/React.createElement(Modal, {
      visible: control,
      transparent: true,
      animationType: "none",
      onRequestClose: () => {
        var _ref$current2, _ref$current2$onReque;
        (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : (_ref$current2$onReque = _ref$current2.onRequestClose) === null || _ref$current2$onReque === void 0 ? void 0 : _ref$current2$onReque.call(_ref$current2);
      }
    }, /*#__PURE__*/React.createElement(Children, _extends({}, props, {
      ref: ref,
      onAnimatedEnd: () => {
        setControl(false);
      }
    })));
  };
}